// need to refactor, so that when the app loads
// it can set these in the main.js file (in a cookie)
// from the secrets bound to whatever is deploying the service
export const APP_CONFIG = {
    ENV: "PROD"
};